<template>
  <div class="analysisReport">
    <!--内容区域-->
    <div class="main-content">
      <sirui-table ref="siruiTable" :loading="load" :data="tableData" :paging="false">
        <!-- <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column> -->
        <vxe-table-column type="index" width="60" :title="$t('table.index')"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        ></vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/tradingQuota/applicationQuota.js';
  // import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';

  export default {
    components: {
      SiruiTable,
      // SiruiSearch,
    },
    name: 'analysisReport',
    data() {
      return {
        load: false,
        tableData: [],
      };
    },
    computed: {
      //表格显示字段
      columnList() {
        return [
          { prop: 'partnerCode', label: this.$t('maintenanceManage.table.partnersCode') },
          { prop: 'partnerName', label: this.$t('maintenanceManage.table.partnersName') },
          { prop: 'demander', label: this.$t('maintenanceManage.table.supplierOrBuyer') },
          {
            prop: 'externalContractNo',
            label: this.$t('maintenanceManage.table.externalContract'),
          },
          { prop: 'contractNo', label: this.$t('maintenanceManage.table.internalContract') },
          { prop: 'contractCategoryName', label: this.$t('maintenanceManage.table.contractType') },
          { prop: 'contractCreateDate', label: this.$t('maintenanceManage.table.contractDate') },
          { prop: 'receiptMethodName', label: this.$t('maintenanceManage.table.paymentMethod') },
          { prop: 'productNo', label: this.$t('maintenanceManage.table.materialCode') },
          { prop: 'productDesc', label: this.$t('maintenanceManage.table.materialDesc') },
          { prop: 'productQuantity', label: this.$t('maintenanceManage.table.number') },
          { prop: 'unitName', label: this.$t('maintenanceManage.table.unit') },
          { prop: 'businessContractUnitPrice', label: this.$t('maintenanceManage.table.price') },
          { prop: 'businessContractTotalAmount', label: this.$t('maintenanceManage.table.amount') },
          {
            prop: 'contractBusinessDepartmentName',
            label: this.$t('maintenanceManage.table.department'),
          },
          { prop: 'productDesc', label: this.$t('maintenanceManage.table.goodsName') },
          // { prop: "remark", label: this.$t("maintenanceManage.table.factory") },//不存在
          { prop: 'contractCurrencyName', label: this.$t('maintenanceManage.table.currency') },
          { prop: 'tradeTypeName', label: this.$t('maintenanceManage.table.TradeType') },
          { prop: 'groupDeliverDate', label: this.$t('maintenanceManage.table.shipmentDate') },
          { prop: 'groupInboundDate', label: this.$t('maintenanceManage.table.portDate') },
          { prop: 'ladingNoSplit', label: this.$t('maintenanceManage.table.MarineNo') },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.$nextTick(() => {
        this.getData();
      });
    },
    methods: {
      //获取数据
      getData() {
        this.load = true;
        this.$axios.get(`${API.LIST_SUMMARY_ANALYSIS_API}/${this.$route.query.id}`).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      //表格选中事件
      currentChange(row) {
        console.log(row);
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        console.log(type);
      },
      //双击事件
      dblclickEvent(value) {
        console.log(value.row);
      },
      /**页面必要代码End */
    },
  };
</script>
